import { useLang } from "../i18n";
import { IMG } from "../content/images";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { NetworkMap } from "../components/NetworkMap";
import { FinalCTA } from "../components/FinalCTA";

const Infrastructure = () => {
  const { t } = useLang();
  return (
    <div data-testid="infrastructure-page">
      <Seo title={t.nav.infrastructure} path="infrastructure" />
      <PageHero eyebrow="BULA TELECOMS SA" title={t.infrastructure.heading} sub={t.infrastructure.intro}
        image={IMG.dataCenter} crumbs={[{ label: t.nav.infrastructure }]} />

      <section className="bg-[#08090A] relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(#FF6600 1px, transparent 1px)", backgroundSize: "28px 28px" }} aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal><NetworkMap label={t.infrastructure.mapLabel} /></Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {t.infrastructure.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 60} className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 hover:border-[#FF6600]/40 transition-colors">
                <h2 className="text-white font-bold text-sm">{item.title}</h2>
                <p className="mt-2 text-xs text-white/55 leading-relaxed">{item.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default Infrastructure;
